<template>
  <el-dialog ref="dialog" v-model="visible" class="dialog" destroy-on-close :title="title" center width=500 show-close @close="handleClose">
    <el-form ref="form" :model="form" label-width="120px" style="margin-top:20px;">
        <el-form-item label="超时时间" prop="timeOut">
            <el-input 
                v-model="form.timeOut" 
                placeholder="请输入超时时间"
                oninput="value=value.replace(/[^\d]/g,'')"
            ></el-input>
        </el-form-item>
        <el-form-item label="超时状态" prop="timeState">
            <el-switch 
            active-value="SUCCESS"
            inactive-value="FAILED"
            v-model="form.timeState" 
            style="--el-switch-on-color: #13ce66; --el-switch-off-color: #ff4949"
            inline-prompt active-text="成功" inactive-text="失败"
         />
        </el-form-item>
    </el-form>
    <template #footer>
      <el-button type="primary" @click="handleSave">保  存</el-button>
      <el-button @click="this.visible = false" >关  闭</el-button>
    </template>
  </el-dialog>
</template>

<script>
import { getTimeOut, setTimeOut } from '@/api/model/admin'
import { ElMessage, ElMessageBox } from 'element-plus'

export default {
    data() {
        return {
            visible: false,
            title:"",
            form:{
                timeOut: "",
                timeState: false,
            }
        }
    },
    methods:{
        open(){
            this.title = "配置超时信息"
            this.visible = true
            getTimeOut().then((res)=>{
                this.form.timeOut = res.data.timeOut
                this.form.timeState = res.data.timeState
            }).catch(() => {})
        },
        handleClose(){
            Object.assign(this.$data, this.$options.data())
        },
        timeOut(){
            getTimeOut().then((res)=>{
                ElMessageBox.prompt('请输入新的超时时间，单位为秒(S)', '设置超时时间', {
                inputErrorMessage: '输入错误',
                inputPlaceholder: res.data.timeOut.toString(),
                }).then((value) =>{
                setTimeOut({timeOut: value.value}).then((res)=>{
                    ElMessage({showClose: true, message: res.msg, type: 'success'});
                }).catch(()=>{})
                }).catch(()=>{})
            }).catch(() => {})
        },
        handleSave(){
            setTimeOut(this.form).then((res)=>{
                ElMessage({showClose: true, message: res.msg, type: 'success'});
                this.handleClose()
            }).catch((res)=>{ })
        }
    }
}
</script>

<style>

</style>